<template>
  <div>
    <span v-if="iconClass" :class="`logo-symbol ${iconClass}`"></span>
    <span v-if="!iconClass" class="label label-default">{{ appName }}</span>
  </div>
</template>
<script>
export default {
  name: 'AppIcon',
  props: {
    appName: {
      type: String,
      required: false
    },
    iconClass: {
      type: String,
      required: false
    }
  }
}
</script>
<style scoped>
.logo-symbol {
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  display: inline;
  padding: 0.1em 0.4em 0.2em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
  border: 2px solid;
}

.barking {
  color: black;
  background-color: #f0ad4e;
  border-color: black !important;
}

.bikeep {
  color: white;
  background-color: #09d65d;
  border-color: #09d65d !important;
}

.wwwash {
  color: white;
  background: linear-gradient(to top left, #3452ff, #ff1053);
  border-color: #3452ff !important;
}

.bikeep:before,
.barking:before {
  content: 'B';
}

.wwwash:before {
  content: 'W';
}
</style>
